const appConstants = {
  cName: "Lystface",
  sName: "lystface",
  lystlocName: "Lystloc",
  logoLight: "https://img-assets.lystface.com/web/logo/logoLight.svg",
  logoDark: "https://img-assets.lystface.com/web/logo/logoDark.svg",
  logoSm: "https://img-assets.lystface.com/web/logo/logoSm.svg",
  favIcon: "https://img-assets.lystface.com/web/logo/logoSm.svg",
  lfLogoDark: "https://img-assets.lystface.com/web/logo/logoDark.svg"
}
export { appConstants }
